export class PageAnalytics {
  constructor() { }

  static gaTrkEvent(cat, action, label, value) {
    if (!window.ga) {
      return;
    }
    if (!cat || !action) {
      return;
    }
    if (label && value) {
      window.ga('send', 'event', cat, action, label, value);
    } else if (label) {
      window.ga('send', 'event', cat, action, label);
    } else {
      window.ga('send', 'event', cat, action);
    }
  }

  static gaTrkCustomDimension(dimension, id) {
    if (!window.ga) {
      return;
    }

    if (!id) {
      return;
    }

    window.ga('set',  dimension, id);
  }

  static gaTrkTiming(cat, timingVar, value, label) {
    if (!window.ga) {
      return;
    }
    if (!cat || !timingVar || !value) {
      return;
    }
    if (label) {
      window.ga('send', 'timing', cat, timingVar, value, label);
    } else {
      window.ga('send', 'timing', cat, timingVar, value);
    }
  }

}


// WEBPACK FOOTER //
// ./src/common/helpers/PageAnalytics.js